import { render, staticRenderFns } from "./discussions.vue?vue&type=template&id=59fab616"
import script from "./discussions.vue?vue&type=script&lang=js"
export * from "./discussions.vue?vue&type=script&lang=js"
import style0 from "./discussions.vue?vue&type=style&index=0&id=59fab616&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports